import ReminderStatusText from './ReminderStatusText.component';

export default ReminderStatusText;
